import BaseService from "./base-service";

export default class MaintenanceService extends BaseService {

    constructor() {
        super('maintenance');
    }
}
